import { connect } from 'react-redux';
import Top10PageComponent from '../components/Top10PageComponent';
import { getTop10DataIfNeeded } from '../actions/Top10Actions';

const mapStateToProps = (state) => ({
    dataTop10: state.top10.dataTop10,
    dataCategories: state.top10.dataCategories,
    isLoading: state.top10.isLoading,
    notFound: state.top10.notFound,
});

const mapDispatchToProps = (dispatch) => ({
    getTop10DataIfNeeded: (idCategory = 1) => {
        dispatch(getTop10DataIfNeeded(idCategory));
    },
});


const Top10PageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Top10PageComponent);

export default Top10PageContainer;
